import { Component, OnInit } from "@angular/core";
import { DocumentsService } from "app/auth/service/documents.service";

@Component({
  selector: "app-replace-field-list",
  templateUrl: "./replace-field-list.component.html",
  styleUrls: ["./replace-field-list.component.scss"],
})
export class ReplaceFieldListComponent implements OnInit {
  constructor(public _documentService: DocumentsService) {}
  ngOnInit(): void {}
}
